export var lpActions = {
    SET_AUTHORIZED_ENTITIES: "SET_AUTHORIZED_ENTITIES",
    SET_AUTHORIZED_LPS: "SET_AUTHORIZED_LPS",
    SET_AUTHORIZED_DSPS: "SET_AUTHORIZED_DSPS",
    SET_SELECTED_LP: "SET_SELECTED_LP"
};
export default lpActions;

//# sourceMappingURL=lpActionTypes.js.map